import React from 'react';
import styles from './PointCard.module.css';

interface PointItem {
  text: string;
}

interface PointCardProps {
  title: string;
  items: PointItem[];
  className?: string;
  useWarningIcon?: boolean;
}

const WarningIcon = () => (
  <svg
    className={styles.warningIcon}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="#daa509ff" d="M1 21h22L12 2 1 21z" />
    <path fill="white" d="M13 16h-2v-5h2v5zm0 4h-2v-2h2v2z" />
  </svg>
);

const PointCard: React.FC<PointCardProps> = ({ title, items, className = '', useWarningIcon = false }) => {
  const isEmpty = items.length === 0;
  
  return (
    <div className={`${styles.pointCard} ${className}`}>
      <div className={styles.cardHeader}>
        <h3>{title}</h3>
      </div>
      <div className={`${styles.cardBody} ${isEmpty ? styles.emptyState : ''}`}>
        {isEmpty ? (
          <div className={styles.noData}>No data available</div>
        ) : useWarningIcon ? (
          <div className={styles.warningList}>
            {items.map((item, index) => (
              <div key={index} className={styles.warningItem}>
                <WarningIcon />
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        ) : (
          <ul className={styles.pointList}>
            {items.map((item, index) => (
              <li key={index} className={styles.pointItem}>
                {item.text}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default PointCard;
